/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Pause = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 1.16504C14.8794 1.16504 18.8349 5.12058 18.835 10C18.8349 14.8794 14.8794 18.835 10 18.835C5.12059 18.8349 1.16506 14.8794 1.16504 10C1.16506 5.1206 5.1206 1.16506 10 1.16504ZM10 2.66504C5.94902 2.66506 2.66506 5.94902 2.66504 10C2.66506 14.051 5.94902 17.3349 10 17.335C14.051 17.335 17.3349 14.051 17.335 10C17.3349 5.94901 14.051 2.66504 10 2.66504ZM11.5732 6C12.8693 6 13.9199 7.05065 13.9199 8.34668V11.5732C13.9199 12.8693 12.8693 13.9199 11.5732 13.9199H8.34668L8.10645 13.9082C6.92325 13.7879 6 12.7882 6 11.5732V8.34668C6 7.13174 6.92324 6.132 8.10645 6.01172L8.34668 6H11.5732ZM8.34668 7.5C7.87908 7.5 7.5 7.87908 7.5 8.34668V11.5732C7.5 12.0408 7.87908 12.4199 8.34668 12.4199H11.5732C12.0408 12.4199 12.4199 12.0408 12.4199 11.5732V8.34668C12.4199 7.87908 12.0408 7.5 11.5732 7.5H8.34668Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Pause;
